import { TFunction } from 'i18next'

import { StepWithArrowOffset } from 'shared/ui/joyride-tour/types.ts'

export const createCalendarSteps = (
  t: TFunction<'translation', undefined>,
): StepWithArrowOffset[] => {
  return [
    {
      target: '#datepicker',
      content: t('tours_block.calendar_guide.datepicker'),
      placement: 'bottom-start',
      disableBeacon: true,
      disableScrolling: true,
      arrowOffset: -140,
    },
  ]
}
